<template>
  <v-card>
    <v-row class="px-5">
      <v-col cols="12">
        <ScorecardBreakdown :breakdownData="breakdownData"/>
      </v-col>
      <v-col cols="12" lg="6">
        <ScorecardTopCond
          :chartLabels="hccCondChartLabels"
          :chartData="hccCondChartData"
        />
      </v-col>
      <v-col cols="12" lg="6">
        <ScorecardOpenCond
          :chartLabels="openCondChartLabels"
          :chartData="openCondChartData"
        />
      </v-col>
      <v-col cols="12">
        <ScorecardMra
          :reportData="reportData"
          :organization="organization"
          :insurance="insurance"
          :group="groups"
          :providers="providers"
          :locations="locations"
          :startDate="startDate"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ScorecardMra from './ScorecardMra';
import ScorecardOpenCond from './ScorecardOpenCond';
import ScorecardTopCond from './ScorecardTopCond';
import ScorecardBreakdown from './ScorecardBreakdown';

export default {
  name: 'Scorecard',
  props: [
    'reportData',
    'organization',
    'insurance',
    'groups',
    'providers',
    'locations',
    'startDate'
  ],
  components: {
    ScorecardMra,
    ScorecardOpenCond,
    ScorecardTopCond,
    ScorecardBreakdown,
  },
  data() {
    return {
      breakdownData: {},
      hccConditionsLabels: [],
      openCondChartLabels: [],
      openCondChartData: [],
      hccCondChartLabels: [],
      hccCondChartData: [],
    };
  },
  mounted() {
  },
  methods: {
    async getScorecardData() {
      this.breakdownData = this.reportData.breakdown;
      this.hccCondChartData = this.reportData.hccCondChartData;
      this.hccCondChartLabels = this.reportData.hccCondChartLabels;
      this.openCondChartData = this.reportData.openCondChartData;
      this.openCondChartLabels = this.reportData.openCondChartLabels;
    },
  },
  watch: {
    reportData() {
      this.getScorecardData()
    }
  },
};
</script>

<style scoped></style>
